"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@bluebase/core");
const DrawerLayout_1 = require("./components/DrawerLayout");
const Avatar_1 = require("./components/Avatar");
const Badge_1 = require("./components/Badge");
const BottomNavigation_1 = require("./components/BottomNavigation");
const BottomNavigationAction_1 = require("./components/BottomNavigationAction");
const Button_1 = require("./components/Button");
const Card_1 = require("./components/Card");
const CardActions_1 = require("./components/CardActions");
const CardContent_1 = require("./components/CardContent");
const CardCover_1 = require("./components/CardCover");
const CardHeader_1 = require("./components/CardHeader");
const Checkbox_1 = require("./components/Checkbox");
const Dialog_1 = require("./components/Dialog");
const DialogAction_1 = require("./components/DialogAction");
const DialogContent_1 = require("./components/DialogContent");
const DialogTitle_1 = require("./components/DialogTitle");
const Divider_1 = require("./components/Divider");
const DrawerItem_1 = require("./components/DrawerItem");
const DrawerSection_1 = require("./components/DrawerSection");
const IconButton_1 = require("./components/IconButton");
const List_1 = require("./components/List");
const ListAvatar_1 = require("./components/ListAvatar");
const ListIcon_1 = require("./components/ListIcon");
const ListItem_1 = require("./components/ListItem");
const ListSubheader_1 = require("./components/ListSubheader");
const Menu_1 = require("./components/Menu/Menu");
const MenuItem_1 = require("./components/Menu/MenuItem");
const Pagination_1 = require("./components/Pagination");
const Picker_1 = require("./components/Picker");
const PickerItem_1 = require("./components/PickerItem");
const Radio_1 = require("./components/Radio");
const RadioGroup_1 = require("./components/RadioGroup");
const Searchbar_1 = require("./components/Searchbar");
const Slider_1 = require("./components/Slider");
const Switch_1 = require("./components/Switch");
const Tab_1 = require("./components/Tab");
const Table_1 = require("./components/Table");
const TableBody_1 = require("./components/TableBody");
const TableCell_1 = require("./components/TableCell");
const TableFooter_1 = require("./components/TableFooter");
const TableHead_1 = require("./components/TableHead");
const TablePagination_1 = require("./components/TablePagination");
const TableRow_1 = require("./components/TableRow");
const TableTitle_1 = require("./components/TableTitle");
const Tabs_1 = require("./components/Tabs/Tabs");
const TextInput_1 = require("./components/TextInput");
const withRtl_1 = tslib_1.__importDefault(require("./withRtl"));
const withTheme_1 = require("./withTheme");
exports.default = core_1.createPlugin({
    categories: ['ui'],
    description: 'Material UI (web) comes to BlueBase!',
    key: 'material-ui',
    name: 'Material UI',
    version: '2.0.0',
    components: {
        Avatar: Avatar_1.Avatar,
        Badge: Badge_1.Badge,
        BottomNavigation: BottomNavigation_1.BottomNavigation,
        BottomNavigationAction: BottomNavigationAction_1.BottomNavigationAction,
        Button: Button_1.Button,
        Card: Card_1.Card,
        CardActions: CardActions_1.CardActions,
        CardContent: CardContent_1.CardContent,
        CardCover: CardCover_1.CardCover,
        CardHeader: CardHeader_1.CardHeader,
        Checkbox: Checkbox_1.Checkbox,
        Dialog: Dialog_1.Dialog,
        DialogActions: DialogAction_1.DialogActions,
        DialogContent: DialogContent_1.DialogContent,
        DialogTitle: DialogTitle_1.DialogTitle,
        Divider: Divider_1.Divider,
        DrawerActions: DrawerLayout_1.DrawerActions,
        DrawerItem: DrawerItem_1.DrawerItem,
        DrawerLayout: DrawerLayout_1.DrawerLayout,
        DrawerSection: DrawerSection_1.DrawerSection,
        IconButton: IconButton_1.IconButton,
        List: List_1.List,
        ListAvatar: ListAvatar_1.ListAvatar,
        ListIcon: ListIcon_1.ListIcon,
        ListItem: ListItem_1.ListItem,
        ListSubheader: ListSubheader_1.ListSubheader,
        Menu: Menu_1.Menu,
        MenuItem: MenuItem_1.MenuItem,
        Pagination: Pagination_1.Pagination,
        Picker: Picker_1.Picker,
        PickerItem: PickerItem_1.PickerItem,
        Radio: Radio_1.Radio,
        RadioGroup: RadioGroup_1.RadioGroup,
        Searchbar: Searchbar_1.Searchbar,
        Slider: Slider_1.Slider,
        Switch: Switch_1.Switch,
        Tab: Tab_1.Tab,
        Table: Table_1.Table,
        TableBody: TableBody_1.TableBody,
        TableCell: TableCell_1.TableCell,
        TableFooter: TableFooter_1.TableFooter,
        TableHead: TableHead_1.TableHead,
        TablePagination: TablePagination_1.TablePagination,
        TableRow: TableRow_1.TableRow,
        TableTitle: TableTitle_1.TableTitle,
        Tabs: Tabs_1.Tabs,
        TextInput: TextInput_1.TextInput,
    },
    filters: {
        'bluebase.boot.end': (bootOptions, _ctx, BB) => {
            BB.Components.addHocs('BlueBaseContent', withRtl_1.default, withTheme_1.withTheme);
            return bootOptions;
        },
    },
});
